// Centralized API configuration
// This function returns the correct backend URL at runtime

export const getBackendUrl = () => {
  // Check if already set
  if (window.__BACKEND_URL__) {
    return window.__BACKEND_URL__;
  }
  
  const hostname = window.location.hostname;
  
  // Production domain
  if (hostname === 'mis.nifpcmc.com') {
    window.__BACKEND_URL__ = 'https://mis.nifpcmc.com';
    return window.__BACKEND_URL__;
  }
  
  // Preview/development
  window.__BACKEND_URL__ = process.env.REACT_APP_BACKEND_URL || window.location.origin;
  return window.__BACKEND_URL__;
};

// For components that need a constant (evaluated at call time)
export const getApiUrl = () => `${getBackendUrl()}/api`;

export default getBackendUrl;
